module.exports = __webpack_public_path__ + "static/media/blue.a2135b75.png";